module.exports = __webpack_public_path__ + "static/media/sponsor.e191f6bc.png";